import React, { useState } from 'react'
import TypeBadge from './TypeBadge'
import { motion } from 'framer-motion'
import { useContext } from 'react'
import { PokemonContext, selectPokemon } from '../Context/PokemonContext'
import { useNavigate, useParams } from 'react-router-dom'
import MissingNoCard from './MissingNoCard'


function Details()
 {
    const {selectedPokemon, selectPokemon} = useContext(PokemonContext)
    const [aboutPokemon, setAboutPokemon] = useState('')
    const { pokemonName } = useParams();
    const navigate = useNavigate()

    if (!selectedPokemon) {
        const fetchPokemon = async () => {
            const res = await fetch(`https://pokeapi.co/api/v2/pokemon/${pokemonName}`);
            const pokemon = await res.json();
            if (res.status === 200) {
                selectPokemon(pokemon)
                const aboutRes = await fetch(pokemon.species.url)
                const aboutDetails = await aboutRes.json()
                if (aboutRes.status === 200) {
                    setAboutPokemon(aboutDetails.flavor_text_entries[0].flavor_text)
                }
            }
          };
          fetchPokemon()
          return (<MissingNoCard/>)
    }

    const fetchAboutPokemon = async () => {
        const aboutRes = await fetch(selectedPokemon.species.url)
        const aboutDetails = await aboutRes.json()
        if (aboutRes.status === 200) {
            setAboutPokemon(aboutDetails.flavor_text_entries[0].flavor_text)
        }
    }

    const fetchNextPokemon = async () => {
        let pokemonId = selectedPokemon.id
        if(selectedPokemon.id < 1025) {
         pokemonId =  selectedPokemon.id += 1
        } else {
            pokemonId = 1
        }
        // selectedPokemon.id + 1 
        const res = await fetch(`https://pokeapi.co/api/v2/pokemon/${pokemonId}`)
        const data = await res.json()
        if(data) {
            selectPokemon(data)
            navigate(`/${data.name}`)
        }
    }

    const fetchPrevPokemon = async () => {
        let pokemonId = selectedPokemon.id
        if(selectedPokemon.id > 1) {
         pokemonId =  selectedPokemon.id -= 1
        } else {
            pokemonId = 1025
        }
        const res = await fetch(`https://pokeapi.co/api/v2/pokemon/${pokemonId}`)
        const data = await res.json()
        if(data) {
            selectPokemon(data)
            navigate(`/${data.name}`)
        }
    }
    fetchAboutPokemon()


    const{name, stats, types, weight, height, id } = selectedPokemon
    const moveOne = selectedPokemon.moves[0].move.name
    const moveTwo = selectedPokemon.moves[1].move.name

    let pokemonTypes = types.map((type) => type.type.name)



  return (
    <div
     className='flex flex-col justify-between bg-white relative w-full h-full p-[4px] pt-0'>
<motion.div
    initial={{ height: 0 }}
    animate={{height: '100%', zIndex: 0}}
    transition={{ duration: .75 }}
 className={`absolute h-full w-full bg-pokemonType-${pokemonTypes[0]} z-0`}></motion.div>

        {/* NEXT */}
        <motion.svg
                  onClick={() => fetchNextPokemon()}
                  initial={{  translateX: '-50px', scale: 0 }}
                  animate={{translateX: 0,  scale: 1}}
                  transition={{ duration: .75, delay: 1 }}
         className=" absolute top-[35%] right-[10%] cursor-pointer" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path className='shadow-[0px_1px_3px_1px_#00000040]' d="M0.849955 11.45C0.716621 11.2834 0.645787 11.1 0.637454 10.9C0.629121 10.7 0.699955 10.525 0.849955 10.375L5.24995 5.97503L0.824954 1.55003C0.691621 1.4167 0.629121 1.23753 0.637454 1.01253C0.645787 0.787533 0.716621 0.608367 0.849955 0.475033C1.01662 0.308367 1.19579 0.2292 1.38745 0.237534C1.57912 0.245867 1.74995 0.325033 1.89995 0.475033L6.87495 5.45003C6.95829 5.53337 7.01662 5.6167 7.04995 5.70003C7.08329 5.78337 7.09995 5.87503 7.09995 5.97503C7.09995 6.07503 7.08329 6.1667 7.04995 6.25003C7.01662 6.33337 6.95829 6.4167 6.87495 6.50003L1.92495 11.45C1.77495 11.6 1.59995 11.6709 1.39995 11.6625C1.19995 11.6542 1.01662 11.5834 0.849955 11.45V11.45Z" fill="white"/>
        </motion.svg>
        {/* prev */}
            <motion.svg
            onClick={() => fetchPrevPokemon()}
                  initial={{  translateX: '50px', scale: 0 }}
                  animate={{translateX: 0, scale: 1}}
                  transition={{ duration: .75, delay: 1 }} className=" absolute top-[35%] left-[10%] cursor-pointer" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className='shadow-[0px_1px_3px_1px_#00000040]' d="M5.47505 11.45L0.525048 6.5C0.441715 6.41667 0.383382 6.33333 0.350049 6.25C0.316716 6.16667 0.300049 6.075 0.300049 5.975C0.300049 5.875 0.316716 5.78333 0.350049 5.7C0.383382 5.61667 0.441715 5.53333 0.525048 5.45L5.50005 0.475C5.65005 0.325 5.82922 0.25 6.03755 0.25C6.24588 0.25 6.42505 0.325 6.57505 0.475C6.72505 0.625 6.79588 0.808333 6.78755 1.025C6.77922 1.24167 6.70005 1.425 6.55005 1.575L2.15005 5.975L6.57505 10.4C6.72505 10.55 6.80005 10.725 6.80005 10.925C6.80005 11.125 6.72505 11.3 6.57505 11.45C6.42505 11.6 6.24171 11.675 6.02505 11.675C5.80838 11.675 5.62505 11.6 5.47505 11.45V11.45Z" fill="white"/>
                </motion.svg>

        <motion.svg
                  initial={{  rotate: '360deg', scale: 0 }}
                  animate={{rotate: 0, scale: 1}}
                  transition={{ duration: .75, delay: .1 }}
         className='absolute z-1 top-5 right-5' width="208" height="208" viewBox="0 0 208 208" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.1">
        <path d="M128.762 104C128.762 117.676 117.676 128.762 104 128.762C90.3244 128.762 79.2381 117.676 79.2381 104C79.2381 90.3244 90.3244 79.2381 104 79.2381C117.676 79.2381 128.762 90.3244 128.762 104Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M104 208C156.393 208 199.738 169.257 206.947 118.857H146.035C139.917 136.169 123.407 148.571 104 148.571C84.5933 148.571 68.0835 136.169 61.9648 118.857H1.05322C8.26235 169.257 51.6067 208 104 208ZM61.9648 89.1429H1.05322C8.26235 38.7431 51.6067 0 104 0C156.393 0 199.738 38.7431 206.947 89.1429H146.035C139.917 71.8314 123.407 59.4286 104 59.4286C84.5933 59.4286 68.0835 71.8314 61.9648 89.1429ZM128.762 104C128.762 117.676 117.676 128.762 104 128.762C90.3244 128.762 79.2381 117.676 79.2381 104C79.2381 90.3244 90.3244 79.2381 104 79.2381C117.676 79.2381 128.762 90.3244 128.762 104Z" fill="white"/>
        </g>
        </motion.svg>

        <div className='flex flex-row items-center px-[20px] pt-[24px] justify-between'>
            <div className='flex flex-row items-center gap-x-[14px]'>
            <motion.svg
                         className="cursor-pointer"
                         onClick={() => navigate('/')}
                         initial={{  translateX: '200%', opacity: 0 }}
                         animate={{translateX: 0, opacity: 1, zIndex: 1}}
                         transition={{ duration: .75, delay: 1 }}
             width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.89992 20.9666L0.633252 11.6999C0.522141 11.5888 0.444363 11.4777 0.399919 11.3666C0.355474 11.2555 0.333252 11.1333 0.333252 10.9999C0.333252 10.8666 0.355474 10.7444 0.399919 10.6333C0.444363 10.5222 0.522141 10.4111 0.633252 10.2999L9.93325 0.999943C10.111 0.822165 10.3333 0.733276 10.5999 0.733276C10.8666 0.733276 11.0999 0.833276 11.2999 1.03328C11.4999 1.23328 11.5999 1.46661 11.5999 1.73328C11.5999 1.99994 11.4999 2.23328 11.2999 2.43328L3.73325 9.99994H20.2666C20.5555 9.99994 20.7944 10.0944 20.9833 10.2833C21.1721 10.4722 21.2666 10.7111 21.2666 10.9999C21.2666 11.2888 21.1721 11.5277 20.9833 11.7166C20.7944 11.9055 20.5555 11.9999 20.2666 11.9999H3.73325L11.3333 19.5999C11.511 19.7777 11.5999 19.9999 11.5999 20.2666C11.5999 20.5333 11.4999 20.7666 11.2999 20.9666C11.0999 21.1666 10.8666 21.2666 10.5999 21.2666C10.3333 21.2666 10.0999 21.1666 9.89992 20.9666V20.9666Z" fill="white"/>
            </motion.svg>

            <motion.h6
            initial={{  translateX: '100%', opacity: 0 }}
            animate={{translateX: 0, opacity: 1, zIndex: 1}}
            transition={{ duration: .75, delay: 1 }}
             className='text-[24px] font-bold text-white relative z-1'>{name}</motion.h6>
            </div>

            <motion.p
            initial={{  scale: 0, opacity: 0 }}
            animate={{scale: 1, opacity: 1, zIndex: 1}}
            transition={{ duration: .75, delay: 1 }}
             className='text-[12px] text-white font-bold z-1 relative'>#{id}</motion.p>
        </div>

        <motion.img
                          initial={{scale: 0 }}
                          animate={{ scale: 1, translateY: '60px'}}
                          transition={{ duration: .75, delay: .6 }}
         className='block mx-auto translate-y-[60px] w-[200px] relative z-10' src={selectedPokemon.sprites.front_default}/>

        <motion.div
              initial={{  translateY: '120%', }}
              animate={{translateY: 0, translateX: '2px', zIndex: 1} }
              transition={{ duration: .75, delay: .5 }}
         className='px-[20px] bottom-0  max-h-[412px] h-full pb-[20px] shadow-[inset_0px_1px_3px_1px_#00000040] translate-x-[2px] z-1 bg-white rounded-[8px] pt-[56px]'>
            <div className='flex items-center justify-center'>
                <TypeBadge types={pokemonTypes}/>
            </div>
            <p className={`text-pokemonType-${pokemonTypes[0]}  my-[16px] font-bold text-[14px]`}>About</p>
            <div className='flex flex-row mx-[30px] justify-between'>
                 {/* Weight */}
                 <div className='flex flex-col items-center justify-center'>
                    <div className='flex gap-x-2 flex-row items-center justify-center'>
                    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.28333 12.0001H10.05L9 4.66675H2.33333L1.28333 12.0001ZM5.66667 3.66675C5.95556 3.66675 6.19444 3.56953 6.38333 3.37508C6.57222 3.18064 6.66667 2.94453 6.66667 2.66675C6.66667 2.37786 6.57222 2.13897 6.38333 1.95008C6.19444 1.76119 5.95556 1.66675 5.66667 1.66675C5.38889 1.66675 5.15278 1.76119 4.95833 1.95008C4.76389 2.13897 4.66667 2.37786 4.66667 2.66675C4.66667 2.94453 4.76389 3.18064 4.95833 3.37508C5.15278 3.56953 5.38889 3.66675 5.66667 3.66675ZM7.4 3.66675H9C9.25556 3.66675 9.47778 3.7473 9.66667 3.90841C9.85556 4.06953 9.96667 4.27786 10 4.53341L11.0333 11.8667C11.0778 12.1667 11.0028 12.4306 10.8083 12.6584C10.6139 12.8862 10.3611 13.0001 10.05 13.0001H1.28333C0.972223 13.0001 0.719445 12.8862 0.525001 12.6584C0.330556 12.4306 0.255556 12.1667 0.300001 11.8667L1.33333 4.53341C1.36667 4.27786 1.47778 4.06953 1.66667 3.90841C1.85556 3.7473 2.07778 3.66675 2.33333 3.66675H3.93333C3.84444 3.51119 3.77778 3.35286 3.73333 3.19175C3.68889 3.03064 3.66667 2.85564 3.66667 2.66675C3.66667 2.11119 3.86111 1.63897 4.25 1.25008C4.63889 0.861192 5.11111 0.666748 5.66667 0.666748C6.22222 0.666748 6.69444 0.861192 7.08333 1.25008C7.47222 1.63897 7.66667 2.11119 7.66667 2.66675C7.66667 2.85564 7.64444 3.03064 7.6 3.19175C7.55556 3.35286 7.48889 3.51119 7.4 3.66675ZM1.28333 12.0001H10.05H1.28333Z" fill="#1D1D1D"/>
                    </svg>
                    <p className='text-[#1D1D1D] text-[10px] font-bold'>{parseFloat(weight / 10)} kg</p>
                    </div>
                    <p className='text-medium mt-2 text-[8px]'>Weight</p>
                 </div>

                 <motion.div
                              initial={{  height: '0' }}
                              animate={{height: '48px' }}
                              transition={{ duration: .2, delay: .75 }}
                  className='bg-[#E0E0E0] h-[48px] w-[1px]'/>

                 <div className='flex flex-col items-center justify-center'>
                    <div className='flex gap-x-2 flex-row items-center justify-center'>
                    <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.5 1.33337C0.5 1.06671 0.6 0.833374 0.8 0.633374C1 0.433374 1.23333 0.333374 1.5 0.333374L7.5 0.333374C7.75556 0.333374 7.98611 0.433374 8.19167 0.633374C8.39722 0.833374 8.5 1.06671 8.5 1.33337V12.6667C8.5 12.9334 8.39722 13.1667 8.19167 13.3667C7.98611 13.5667 7.75556 13.6667 7.5 13.6667H1.5C1.23333 13.6667 1 13.5667 0.8 13.3667C0.6 13.1667 0.5 12.9334 0.5 12.6667L0.5 1.33337ZM1.5 1.33337L1.5 12.6667H7.5V10.5H4.5V9.50004H7.5L7.5 7.50004H4.5V6.50004H7.5V4.50004H4.5V3.50004L7.5 3.50004V1.33337L1.5 1.33337ZM4.5 3.50004V4.50004V3.50004ZM4.5 6.50004V7.50004V6.50004ZM4.5 9.50004V10.5V9.50004Z" fill="#1D1D1D"/>
                    </svg>
                    <p className='text-[#1D1D1D] text-[10px] font-bold'>{parseFloat(height / 10)} m</p>
                    </div>
                    <p className='text-medium mt-2 text-[8px]'>Height</p>
                 </div>

                 <motion.div
                              initial={{  height: '0' }}
                              animate={{height: '48px' }}
                              transition={{ duration: .2, delay: .75 }}
                  className='bg-[#E0E0E0] h-[48px] w-[1px]'/>


                 <div className='flex mb-2 flex-col items-center justify-center'>
                    <div className='flex gap-x-2 flex-row items-center justify-center'>
                    {/* <p className='text-[#1D1D1D] text-[10px] font-bold'>6.9 kg</p> */}
                    <div className='flex flex-col items-center gap-y-1'>
                        <p className='text-[#1D1D1D] text-[10px] font-bold'>{moveOne}</p>
                        <p className='text-[#1D1D1D] text-[10px] font-bold'>{moveTwo}</p>
                    </div>
                    </div>
                    <p className='text-medium mt-2 text-[8px]'>Moves</p>
                 </div>
            </div>
             <p className='text-left text-[10px] block mx-auto px-[16px] mt-2'>{aboutPokemon}</p>

             <p className={` text-pokemonType-${pokemonTypes[0]} my-[16px] font-bold text-[14px]`}>Stats</p>

             <div className='flex flex-row justify-between '>
                <div className='flex flex-col items-end gap-y-[4px]'>
                {
                            stats.map((stat) => {
                                let statName;
                                switch(stat.stat.name) {
                                    case 'special-attack':
                                        statName = 'SATK';
                                        break;
                                    case 'special-defense':
                                        statName = 'SDEF';
                                        break;
                                    default:
                                        statName = stat.stat.name.toUpperCase();
                                        break;
                                }
                                return (
                                    <p className={`text-[10px] text-pokemonType-${pokemonTypes[0]} font-bold text-[10px]`}>{statName}</p>
                                )
                            })
                    }
                </div>
                
                <div
                 className='h-[110px] w-[1px] bg-[#E0E0E0]'/>

                <div className='flex flex-col items-end gap-y-[4px]'>

                {
                            stats.map((stat) => {
                                return (
                                    <p className='text-[10px] text-[#1D1D1D] font-bold text-[10px]'>{stat.base_stat}</p>
                                )
                            })
                    }
                </div>
                <div className='flex flex-col justify-between'>

                {
                            stats.map((stat) => {
                                return (
                                    <div className={`w-[233px] rounded-full my-[6px] h-[4px] bg-pokemonType-${pokemonTypes[0]} bg-opacity-20 relative`}>
                                    <motion.div
                                    initial={{width: 0 }}
                                    animate={{ width: `${Number(stat.base_stat) / 255 * 100}%` }}
                                    transition={{ duration: .75, delay: .66, ease: 'linear' }}
                                     className={` absolute left-0 h-[4px] bg-pokemonType-${pokemonTypes[0]} rounded-full`}></motion.div>
                                    </div>
                                )
                            })
                    }
                </div>
             </div>


        </motion.div>

    </div>
  )
}

export default Details